var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState, useEffect } from "react";
import MasterHook from "master-hook";
import * as App from "./use-app";
import * as Auth from "./use-auth";
import * as I18n from "./use-i18n";
import { makeHook } from "./default-hook";
import { client } from "./services";
import AsyncStorage from "@react-native-async-storage/async-storage";
MasterHook.useDevTools(process.env.NODE_ENV === "development");
MasterHook.setLocalStorage(AsyncStorage);
export var useApp = MasterHook(App);
export var useAuth = MasterHook(Auth);
export { useAuthTabSync } from "./use-auth";
export var useI18n = MasterHook(I18n);
export var useStorages = MasterHook(makeHook("Storage", {
    defaultState: {
        category: "active",
    },
}));
export var useUser = MasterHook(makeHook("User", {
    defaultState: {
        category: "active",
    },
}));
export var useProduct = MasterHook(makeHook("Product", {
    res: {
        item: {
            products: __assign(__assign({}, client.all), { product: client.all }),
            category: client.all,
            brand: client.all,
        },
        list: __assign(__assign({}, client.all), { productCategoryData: client.all, productBrandData: client.all })
    },
    defaultState: {
        category: "active",
    },
}));
export var useCheckPriceLink = MasterHook(makeHook("CheckPriceLink", {
    res: {
        item: {
            checkPriceMonitor: client.all,
            checkPriceLinkChangesHistory: client.all,
        },
    },
    defaultState: {
        category: "active",
    },
}));
export var useCheckPriceMonitor = MasterHook(makeHook("CheckPriceMonitor", {
    res: {
        item: {
            product: client.all,
        },
    },
    defaultState: {
        category: "active",
    },
}));
export var useProductBrand = MasterHook(makeHook("ProductBrand", {
    defaultState: {
        category: "active",
    },
}));
export var useProductCategory = MasterHook(makeHook("ProductCategory", {
    res: { item: { parent: client.all } },
    defaultState: {
        category: "active",
    },
}));
var getDefaultStorageDocumentsFilters = function () {
    var now = new Date();
    var start = new Date(now.getFullYear(), now.getMonth(), 1);
    var end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
    return {
        dateFrom: start.toISOString(),
        dateTo: end.toISOString(),
    };
};
export var useStorageDocuments = MasterHook(makeHook("StorageDocuments", {
    res: {
        list: {
            products: {
                product: client.all,
            },
        },
        item: {
            products: __assign(__assign({}, client.all), { product: client.all, productSetData: client.all }),
            storageIn: client.all,
            storageOut: client.all,
            linkedDocuments: __assign({}, client.all),
        },
    },
    defaultState: {
        category: "active",
        filters: getDefaultStorageDocumentsFilters(),
    },
}));
export var useStorageShipments = MasterHook(makeHook("StorageShipments", {
    res: {
        list: {
            products: {
                product: client.all,
            },
        },
        item: {
            products: __assign(__assign({}, client.all), { product: client.all }),
            linkedDocuments: client.all,
        },
    },
    defaultState: {
        category: "active",
        filters: {
            dateFrom: new Date(new Date().getFullYear(), 0, 1).toISOString(),
            dateTo: new Date(new Date().getFullYear(), 11, 31, 23, 59, 59, 999).toISOString(),
        },
    },
}));
var getDefaultSalesFilters = function () {
    var now = new Date();
    var start = new Date(now.getFullYear(), now.getMonth(), 1);
    var end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
    return {
        dateFrom: start.toISOString(),
        dateTo: end.toISOString(),
    };
};
export var useSales = MasterHook(makeHook("Sales", {
    res: {
        item: {
            products: __assign(__assign({}, client.all), { product: client.all }),
            deliveryService: client.all,
            paymentAccount: client.all,
            deliveryFromAccount: client.all,
            deliveryFromStorage: client.all,
            sourceOrder: client.all,
            linkedDocuments: client.all,
        },
        list: {
            products: {
                product: client.all,
            },
        },
    },
    defaultState: {
        category: "active",
        filters: getDefaultSalesFilters(),
    },
}));
var getDefaultTransactionsFilters = function () {
    var now = new Date();
    var start = new Date(now.getFullYear(), now.getMonth(), 1);
    var end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
    return {
        dateFrom: start.toISOString(),
        dateTo: end.toISOString(),
    };
};
export var useTransactions = MasterHook(makeHook("Transactions", {
    res: {
        item: {
            transactionArticles: client.all,
            accountIn: client.all,
            accountOut: client.all,
            linkedDocuments: client.all,
        },
    },
    defaultState: {
        category: "active",
        filters: getDefaultTransactionsFilters(),
    },
}));
export var useI18nLang = MasterHook(makeHook("I18nLang", {
    defaultState: {
        category: "active",
    },
}));
export var useAccount = MasterHook(makeHook("Account", {
    defaultState: {
        category: "active",
    },
}));
export var useTransactionArticles = MasterHook(makeHook("TransactionArticles", {
    defaultState: {
        category: "active",
    },
}));
export var useSourceOrders = MasterHook(makeHook("SourceOrders", {
    defaultState: {
        category: "active",
    },
}));
var getDefaultOzonPostingsFilters = function () {
    var now = new Date();
    var monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
    var monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
    return {
        dateFrom: monthStart.toISOString(),
        dateTo: monthEnd.toISOString(),
    };
};
var getDefaultWbPostingsFilters = function () {
    var now = new Date();
    var monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
    var monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
    return {
        dateFrom: monthStart.toISOString(),
        dateTo: monthEnd.toISOString(),
    };
};
var getDefaultAvitoPostingsFilters = function () {
    var now = new Date();
    var monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
    var monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
    return {
        dateFrom: monthStart.toISOString(),
        dateTo: monthEnd.toISOString(),
    };
};
export var useOzonSellerAccounts = MasterHook(makeHook("OzonSellerAccounts", {
    defaultState: {
        category: "active",
    },
}));
export var useOzonPostings = MasterHook(makeHook("OzonPostings", {
    res: {
        list: __assign(__assign({}, client.all), { account: client.all, products: __assign(__assign({}, client.all), { snapshotCostPriceRub: true, snapshotCostPricedAt: true, effectiveUnitCostRub: true, lineCostRub: true, product: {
                    id: true,
                    name: true,
                    preview: true,
                    hsCode: true,
                    costPriceRub: true,
                    rrc: true,
                    articles: true,
                } }), taxBaseFromCustomerPrice: true, taxBaseCustomerCurrencyCode: true, orderProfitRub: true }),
        item: __assign(__assign({}, client.all), { account: client.all, products: __assign(__assign({}, client.all), { snapshotCostPriceRub: true, snapshotCostPricedAt: true, effectiveUnitCostRub: true, lineCostRub: true, product: {
                    id: true,
                    name: true,
                    preview: true,
                    hsCode: true,
                    costPriceRub: true,
                    rrc: true,
                    articles: true,
                } }), accruals: {
                operations: {
                    operationId: true,
                    operationType: true,
                    operationDate: true,
                    operationTypeName: true,
                    amount: true,
                    type: true,
                    postingNumber: true,
                    productName: true,
                    sku: true,
                    quantity: true,
                    price: true,
                },
                totals: {
                    accrualsForSale: true,
                    saleCommission: true,
                    processingAndDelivery: true,
                    refundsAndCancellations: true,
                    servicesAmount: true,
                    compensationAmount: true,
                    moneyTransfer: true,
                    othersAmount: true,
                    deliveryCharge: true,
                    returnDeliveryCharge: true,
                },
                financialDataFromGet: {
                    products: {
                        productId: true,
                        commissionAmount: true,
                        commissionPercent: true,
                        payout: true,
                        oldPrice: true,
                        price: true,
                        totalDiscountValue: true,
                        totalDiscountPercent: true,
                        customerPrice: true,
                        currencyCode: true,
                        customerCurrencyCode: true,
                    },
                    clusterFrom: true,
                    clusterTo: true,
                    syncedAt: true,
                },
                getPayloadJson: true,
                totalFromOperations: true,
                orderCostRubTotal: true,
                orderProfitRub: true,
            } }),
    },
    defaultState: {
        category: "awaiting",
        filters: getDefaultOzonPostingsFilters(),
        sorting: [{ by: "desc", order: "inProcessAt" }],
    },
}));
export var useWbSellerAccounts = MasterHook(makeHook("WbSellerAccounts", {
    defaultState: {
        category: "active",
    },
}));
export var useAvitoSellerAccounts = MasterHook(makeHook("AvitoSellerAccounts", {
    defaultState: {
        category: "active",
    },
}));
export var useAvitoPostings = MasterHook(makeHook("AvitoPostings", {
    res: {
        list: __assign(__assign({}, client.all), { account: client.all, orderCreatedAt: true, orderUpdatedAt: true, products: __assign(__assign({}, client.all), { product: {
                    id: true,
                    name: true,
                    preview: true,
                    hsCode: true,
                    costPriceRub: true,
                    rrc: true,
                    articles: true,
                } }), orderProfitRub: true }),
        item: __assign(__assign({}, client.all), { account: client.all, orderCreatedAt: true, orderUpdatedAt: true, products: __assign(__assign({}, client.all), { product: {
                    id: true,
                    name: true,
                    preview: true,
                    hsCode: true,
                    costPriceRub: true,
                    rrc: true,
                    articles: true,
                } }), financialPayloadJson: true }),
    },
    defaultState: {
        category: "awaiting",
        filters: getDefaultAvitoPostingsFilters(),
        sorting: [{ by: "desc", order: "orderUpdatedAt" }],
    },
}));
export var useWbPostings = MasterHook(makeHook("WbPostings", {
    res: {
        list: __assign(__assign({}, client.all), { account: client.all, products: __assign(__assign({}, client.all), { product: {
                    id: true,
                    name: true,
                    preview: true,
                    hsCode: true,
                    costPriceRub: true,
                    rrc: true,
                    articles: true,
                } }) }),
        item: __assign(__assign({}, client.all), { account: client.all, products: __assign(__assign({}, client.all), { product: {
                    id: true,
                    name: true,
                    preview: true,
                    hsCode: true,
                    costPriceRub: true,
                    rrc: true,
                    articles: true,
                } }), accruals: {
                operations: client.all,
                totals: client.all,
                financialDataFromGet: client.all,
                getPayloadJson: true,
                totalFromOperations: true,
                orderCostRubTotal: true,
                orderProfitRub: true,
                financePrioritySource: true,
            } }),
    },
    defaultState: {
        category: "awaiting",
        filters: getDefaultWbPostingsFilters(),
        sorting: [{ by: "desc", order: "inProcessAt" }],
    },
}));
export var useWbCatalogProducts = MasterHook(makeHook("WbCatalogProducts", {
    res: {
        list: __assign(__assign({}, client.all), { account: client.all, linkedProduct: {
                id: true,
                name: true,
                preview: true,
                hsCode: true,
                costPriceRub: true,
                rrc: true,
                articles: true,
            } }),
        item: __assign(__assign({}, client.all), { account: client.all, linkedProduct: {
                id: true,
                name: true,
                preview: true,
                hsCode: true,
                costPriceRub: true,
                rrc: true,
                articles: true,
            } }),
    },
    defaultState: {
        category: "active",
        sorting: [{ by: "desc", order: "updatedAt" }],
    },
}));
export var useDeliveryServices = MasterHook(makeHook("DeliveryServices", {
    defaultState: {
        category: "active",
    },
}));
export var useGroups = MasterHook(makeHook("Groups", {
    defaultState: {
        category: "active",
    },
}));
export var useI18nKeys = MasterHook(makeHook("I18nKey", {
    res: { item: { i18n: client.all } },
    defaultState: {
        category: "active",
    },
}));
export var useSitesScroller = MasterHook(makeHook("SitesScroller", {
    defaultState: {
        category: "active",
    },
}));
export var useSitesPages = MasterHook(makeHook("SitesPages", {
    res: {
        item: {
            linkedDocuments: client.all,
        },
    },
    defaultState: {
        category: "active",
    },
}));
export var useSitesNews = MasterHook(makeHook("SitesNews", {
    defaultState: {
        category: "active",
    },
}));
export var useSitesShopCategories = MasterHook(makeHook("SitesShopCategories", {
    res: {
        item: {
            linkedDocuments: client.all,
            parent: client.all,
        },
    },
    defaultState: {
        category: "active",
    },
}));
export var useSitesShopProducts = MasterHook(makeHook("SitesShopProducts", {
    res: {
        list: {
            product: __assign(__assign({}, client.all), { productSetItems: client.all }),
        },
        item: {
            category: client.all,
            linkedDocuments: client.all,
            product: __assign(__assign({}, client.all), { productSetItems: client.all }),
        }
    },
    defaultState: {
        category: "active",
    },
}));
export var useSitesShopPayment = MasterHook(makeHook("SitesShopPayment", {
    defaultState: {
        category: "active",
    },
}));
export var useSitesShopDelivery = MasterHook(makeHook("SitesShopDelivery", {
    defaultState: {
        category: "active",
    },
}));
export var useProcurementSuppliers = MasterHook(makeHook("ProcurementSupplier", {
    res: {
        list: __assign(__assign({}, client.all), { site: true }),
        item: __assign(__assign({}, client.all), { site: true }),
    },
    defaultState: { category: "active", filters: {} },
}));
var procurementRequestBase = makeHook("ProcurementRequest", {
    res: {
        list: {
            currency: true,
            request_status: true,
            tradeTerms: true,
            supplier: __assign(__assign({}, client.all), { nameNative: true, nameEnglish: true, nameRussian: true, countryCode: true, address: true, addressNative: true, addressEnglish: true, addressRussian: true, contactName: true, contactNameNative: true, contactNameEnglish: true, contactNameRussian: true, phone: true, email: true, site: true, bankAccountNumber: true, bankCorrAccountNumber: true, bankBic: true, bankCnapsCode: true, bankSwiftCode: true, bankName: true, bankAddress: true }),
            buyer: __assign(__assign({}, client.all), { nameNative: true, nameEnglish: true, nameRussian: true, countryCode: true, address: true, addressNative: true, addressEnglish: true, addressRussian: true, contactName: true, contactNameNative: true, contactNameEnglish: true, contactNameRussian: true, phone: true, email: true, site: true, bankAccountNumber: true, bankCorrAccountNumber: true, bankBic: true, bankCnapsCode: true, bankSwiftCode: true, bankName: true, bankAddress: true }),
            contract: { id: true, name: true, description: true, currency: true, supplier: client.all, buyer: client.all },
            items: {
                id: true,
                productName: true,
                description: true,
                quantity: true,
                price: true,
                amount: true,
                costPrice: true,
                additionalCostPrice: true,
                comment: true,
                sortOrder: true,
                images: true,
                imageSlotId: true,
            },
            expenses: { id: true, amount: true, rate: true, amountInMainCurrency: true, comment: true, isPaymentForInvoice: true },
        },
        item: {
            documentNumber: true,
            documentDate: true,
            tradeTerms: true,
            currency: true,
            totalAmount: true,
            comment: true,
            expensesComment: true,
            importantNote: true,
            request_status: true,
            expenses: { id: true, amount: true, rate: true, amountInMainCurrency: true, comment: true, isPaymentForInvoice: true },
            supplier: __assign(__assign({}, client.all), { nameNative: true, nameEnglish: true, nameRussian: true, countryCode: true, address: true, addressNative: true, addressEnglish: true, addressRussian: true, contactName: true, contactNameNative: true, contactNameEnglish: true, contactNameRussian: true, phone: true, email: true, site: true, bankAccountNumber: true, bankCorrAccountNumber: true, bankBic: true, bankCnapsCode: true, bankSwiftCode: true, bankName: true, bankAddress: true }),
            buyer: __assign(__assign({}, client.all), { nameNative: true, nameEnglish: true, nameRussian: true, countryCode: true, address: true, addressNative: true, addressEnglish: true, addressRussian: true, contactName: true, contactNameNative: true, contactNameEnglish: true, contactNameRussian: true, phone: true, email: true, site: true, bankAccountNumber: true, bankCorrAccountNumber: true, bankBic: true, bankCnapsCode: true, bankSwiftCode: true, bankName: true, bankAddress: true }),
            contract: {
                id: true,
                name: true,
                description: true,
                currency: true,
                contract_number: true,
                contract_date: true,
                supplier: client.all,
                buyer: client.all,
            },
            items: {
                id: true,
                productName: true,
                description: true,
                quantity: true,
                price: true,
                amount: true,
                costPrice: true,
                additionalCostPrice: true,
                comment: true,
                sortOrder: true,
                availableQuantity: true,
                images: true,
                imageSlotId: true,
                product: { id: true, name: true, preview: true, shortDescription: true },
            },
        },
    },
    defaultState: { category: "active" },
});
export var useProcurementRequests = MasterHook(procurementRequestBase);
export var useProcurementContracts = MasterHook(makeHook("ProcurementContract", {
    defaultState: { category: "active" },
    res: {
        list: {
            currency: true,
            requests: { id: true, documentNumber: true },
            supplier: { id: true, name: true, countryCode: true },
            buyer: { id: true, name: true, countryCode: true },
        },
        item: {
            currency: true,
            supplier: client.all,
            buyer: client.all,
        },
    },
}));
export var useProcurementDeliveries = MasterHook(makeHook("ProcurementDelivery", {
    defaultState: { category: "active" },
    res: {
        list: {
            contract: { id: true, name: true },
            requests: { id: true, documentNumber: true },
        },
        item: {
            tradeTerms: true,
            gtd: true,
            comment: true,
            expensesComment: true,
            shipmentData: true,
            contract: {
                id: true,
                name: true,
                description: true,
                currency: true,
                supplier: client.all,
                buyer: client.all,
            },
            requests: {
                id: true,
                documentNumber: true,
                documentDate: true,
                currency: true,
                tradeTerms: true,
                totalAmount: true,
                request_status: true,
                comment: true,
                importantNote: true,
                items: {
                    id: true,
                    productName: true,
                    description: true,
                    quantity: true,
                    price: true,
                    amount: true,
                    costPrice: true,
                    additionalCostPrice: true,
                    comment: true,
                    sortOrder: true,
                    images: true,
                    imageSlotId: true,
                    product: { id: true, name: true, preview: true, shortDescription: true },
                },
            },
            items: __assign(__assign({}, client.all), { kitName: true, product: { id: true, name: true, preview: true, shortDescription: true }, components: __assign(__assign({}, client.all), { requestItem: {
                        id: true,
                        productName: true,
                        description: true,
                        quantity: true,
                        price: true,
                        amount: true,
                        costPrice: true,
                        additionalCostPrice: true,
                        comment: true,
                        sortOrder: true,
                        availableQuantity: true,
                        images: true,
                        imageSlotId: true,
                        product: { id: true, name: true, preview: true, shortDescription: true },
                    } }) }),
            boxes: __assign(__assign({}, client.all), { items: __assign(__assign({}, client.all), { deliveryItem: client.all }) }),
            expenses: { id: true, amount: true, rate: true, amountInMainCurrency: true, comment: true },
        },
    },
}));
export var useDocumentTemplates = MasterHook(makeHook("DocumentTemplate", {
    res: {
        item: {
            id: true,
            createdAt: true,
            updatedAt: true,
            name: true,
            description: true,
            assetCode: true,
            templateType: true,
            pageOrientation: true,
            templateHtml: true,
            status: true,
        },
        list: {
            id: true,
            createdAt: true,
            updatedAt: true,
            name: true,
            description: true,
            assetCode: true,
            templateType: true,
            pageOrientation: true,
            templateHtml: true,
            status: true,
        },
    },
    defaultState: { category: "active" },
}));
// Backward compatibility alias
export var useProcurementDocTemplates = useDocumentTemplates;
/** Список модулей (резолверов) для настройки прав в группах */
export var useListResolvers = function () {
    var _a = useState([]), resolvers = _a[0], setResolvers = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    useEffect(function () {
        client
            .query({ listResolvers: { key: true, name: true, description: true } })
            .then(function (r) {
            var _a;
            setResolvers((_a = r === null || r === void 0 ? void 0 : r.listResolvers) !== null && _a !== void 0 ? _a : []);
        })
            .finally(function () { return setLoading(false); });
    }, []);
    return { resolvers: resolvers, loading: loading };
};
